<template>
    <modal
        name="crearPrecio"
        transition="pop-out"
        :width="800"
        height="auto"
        :scrollable="true"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2>Crear nuevo tipo de abono</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close(false)">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <FormPrecio :tipo="tipo" v-on:terminado="crearPrecio()"/>
            </div>
            <div class="card-footer text-right">
                <Button type="button" name="button" @click.prevent="close(false)" :disabled="loading">CERRAR</Button>
            </div>
        </div>
    </modal>
</template>

<script>

    import FormPrecio from './sin-recinto/FormPrecio';

    export default {
        props: ['lista_id'],
        data() {
            return {
                loading: false,
                tipo: {
                    filters: {},
                    activo : 0,
                    precio: 0,
                    venta_online_cerrada: 0,
                    lista_id: this.lista_id
                }
            }
        },
        methods: {
            close(creado) {
                this.tipo = {
                    activo : 0,
                    precio: 0
                }
                this.$emit('close', 'crearPrecio', creado);
            },
            crearPrecio() {
                this.loading = true;

                if(this.tipo.activo) {
                    this.tipo.activo = 1;
                } else {
                    this.tipo.activo = 0;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.precios.crear'), this.tipo).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            }
        },
        components: {
            FormPrecio
        }
    }
</script>
